import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { get } from "lodash";

import SkillModal from "../SkillModal";
import InstructionalReportBatchPrint from "./InstructionalReportBatchPrint";

import Loading from "../../../Global/Loading";
import { setSkillsStatusState } from "../../state/skillsstatus/actions";

import Content from "./Content";

import "./index.scss";
import "rc-tooltip/assets/bootstrap_white.css";
import { useNavigate } from "react-router-dom";

export default function ReadingRope(props) {
  const [skillModalData, setSkillModalData] = useState(null);
  const navigate = useNavigate();
  const prevStatusRef = useRef(null);

  const batchPrint = useSelector(state => state.reports.roster.batchPrint)

  const dispatch = useDispatch();
  const setState = (state) => dispatch(setSkillsStatusState(state));

  const roster = useSelector((state) => state.reports.roster);
  const studentId = get(roster, "ui.selections.student.value", null);
  const classObj = get(roster, "ui.selections.classroom", null);

  const report = useSelector((state) => state.reports.readingrope.report);
  const status = get(report, "status.type", null);
  const data = get(report, "data.readingRopeReport", null);

  const selectedLocale = useSelector((state) => state.reports.teacher.selectedLocale);
  const selectedScreeningWindow = useSelector((state) => state.reports.teacher.selectedScreeningWindow);

  useEffect(() => {
    props.initializeData();
  }, []);

  // Effect to refetch data when screening window changes
  useEffect(() => {
    if (selectedScreeningWindow) {
      props.initializeData();
    }
  }, [selectedScreeningWindow]);

  // Effect to detect when data loading completes
  useEffect(() => {
    // Check if status has changed to "COMPLETE"
    if (prevStatusRef.current !== "COMPLETE" && status === "COMPLETE") {
      // If onDataLoaded callback exists, call it
      if (props.onDataLoaded) {
        props.onDataLoaded();
      }
    }
    // Update the ref with current status for next comparison
    prevStatusRef.current = status;
  }, [status, props.onDataLoaded]);

  const navigation = (domainValue) => {
    if (!studentId) {
      setState({ domain: domainValue });
      navigate("/teacher/reports/type/skillsstatus");
    } else {
      navigate(`/teacher/reports/type/skillsdiagnostic`);
    }
  };

  return (
       <div className="report-container" style={{padding: 0}}>
      <SkillModal
        data={skillModalData ? { ...skillModalData, studentId } : null}
        onClose={() => setSkillModalData(null)}
        isReadingRope={true}
      />
      {renderContent()}
    </div>
  );

  function renderContent() {
    if (status === "ERROR")
      return (
        <div className="filler-text">
          Error: unable to retrieve reading rope report.
        </div>
      );

    if (status === "PENDING" || !data)
      return (
        <div style={{ height: 500 }}>
          <Loading />
        </div>
      );

    const student = get(roster, "ui.selections.student", null);

    return (
      <React.Fragment>
      {batchPrint ? <InstructionalReportBatchPrint selectedLocale={selectedLocale} /> :
        <Content
          navigation={navigation}
          student={student ? student.ui : null}
          classroom={classObj}
          readingRopeReport={report.data}
          setSkillModalData={setSkillModalData}
        />
      }
      </React.Fragment>
    );
  }
}
